import * as Constants from '../../constants.js';

import { useEffect, useState } from 'react';

import SummaryCards from './dashboard/SummaryCards';
import Calendar from './dashboard/Calendar';
import Tools from './Tools';

const Dashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [commitments, setCommitments] = useState([]);
  const [commitmentTypes, setCommitmentTypes] = useState([]);
  const [statusTypes, setStatusTypes] = useState([]);
  const [selectedCommitment, setSelectedCommitment] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(true);


  useEffect(() => {

    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {

      try {
        setIsLoading(true);

        const token = localStorage.getItem("token");

        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        };

        const [commitmentsRes] = await Promise.all([
          fetch(Constants.COMMITMENTS_LIST, { method: 'GET', signal, headers })
        ]);

        if (!commitmentsRes.ok) {
          const err = await commitmentsRes.json();
          throw err;
        }

        const commitmentsJson = await commitmentsRes.json();

        if (commitmentsJson.status === "success") {
          setCommitments(commitmentsJson.data);
        }
      } catch (error) {

        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

    return () => controller.abort();
  }, []);


  const handleEdit = (externalsystem) => {
    setSelectedCommitment(externalsystem);
    setShowModal(true);
  }

  const handleDelete = (commitment) => {
    setSelectedCommitment(commitment)
    setShowDeleteModal(true)
  }

  const handleDeleteConfirmation = (id) => {
    setShowDeleteModal(false)
    setIsLoading(true);

    const controller = new AbortController();
    const signal = controller.signal;
    const token = localStorage.getItem("token");

    fetch(Constants.COMMITMENTS_DELETE, {
      method: 'DELETE',
      signal: signal,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',

      },
      body: JSON.stringify({ id: id }),
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(responseJson => {
        if (responseJson.status === "success") {
          setCommitments(prevCommitments => prevCommitments.filter(commitment => commitment.id !== id));
        } else {
          console.error('Erro na API:', responseJson.message);
        }
        setSelectedCommitment(null);
        setIsLoading(false);
      })
      .catch(error => {
        if (error.name === 'AbortError') return;

        console.error('Erro na requisição de remoção:', error.message || error);
        setIsLoading(false);
      });
  }

  const handleCreate = () => {
    setSelectedCommitment(null);
    setShowModal(true)
  }

  const handleSave = (commitment) => {
    setIsLoading(true);

    let url = Constants.COMMITMENTS_CREATE
    let method = 'POST'
    if (commitment.id) {
      url = Constants.COMMITMENTS_UPDATE
      method = 'PUT'
    }
    const controller = new AbortController();
    const signal = controller.signal;

    const token = localStorage.getItem("token");

    fetch(url, {
      method: method,
      signal: signal,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(commitment),
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(responseJson => {
        if (responseJson.status === "success") {
          const savedCommitment = responseJson.data; // O usuário que veio do banco
          if (commitment.id) {
            // Se for EDIÇÃO: substitui o usuário antigo pelo novo no array
            setCommitments(prev => prev.map(u => u.id === savedCommitment.id ? savedCommitment : u));
          } else {
            // Se for CRIAÇÃO: adiciona o novo usuário ao final (ou início) da lista
            setCommitments(prev => [...prev, savedCommitment]);
          }

          // Se preferir recarregar tudo do zero, chame sua função de fetch inicial:
          // fetchAllCommitments(); 
        }
        setIsLoading(false);
      })
      .catch(error => {
        if (error.name === 'AbortError') {
          return;
        }
        console.error('Erro na requisição:', error.message || error);
        setIsLoading(false);
      });
  };


  return (
    <div>

      <SummaryCards />

      <div className="row g-2 mt-1">
        <div className="col-9 col-xl-9">
          <Calendar commitments={commitments} />
        </div>

        <div className="col-3 col-xl-3 h-100 rounded-1">
          <Tools />
        </div>
      </div>

      {/* <CommitmentFormModal show={showModal} onHide={() => setShowModal(false)} onSave={handleSave} user={selectedCommitment} /> */}
    </div>
  );
};

export default Dashboard;